module.exports = __webpack_public_path__ + "static/media/aIMG_4677.f10ad0f2.JPG";